import React from 'react';
import {motion} from 'framer-motion';
import {siteData} from '../../data/content';
import * as FiIcons from 'react-icons/fi';
const {FiAlertTriangle,FiScissors,FiDroplet,FiZap,FiWind,FiArrowRight,FiPhone}=FiIcons;

const iconMap={
  AlertTriangle: FiAlertTriangle,
  Scissors: FiScissors,
  Droplet: FiDroplet,
  Zap: FiZap,
  Wind: FiWind,
};

const BOOKING_URL="https://app.urable.com/virtual-shop/cFNwotdAvEx76Evup5X1";

export default function AddOnsSection() {
  return ( 
    <section className="py-24 bg-slate-950 border-b border-slate-800"> 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"> 
          <div> 
            <span className="text-blue-500 font-bold tracking-widest uppercase text-xs mb-3 block">Customize Your Service</span> 
            <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-6"> 
              Add-On Services 
            </h2> 
            <p className="text-slate-400 text-lg mb-10 leading-relaxed"> 
              Need something extra? Enhance any package with our professional add-on services. Pricing is customized based on your vehicle's condition. 
            </p> 
            <div className="space-y-4"> 
              {siteData.addons.map((addon,i)=> {
                const Icon=iconMap[addon.icon] || FiZap;
                return ( 
                  <motion.div key={i} initial={{opacity: 0,x: -16}} whileInView={{opacity: 1,x: 0}} viewport={{once: true}} transition={{delay: i * 0.07}} className="flex items-start gap-4 bg-slate-900 border border-slate-800 p-5 rounded-sm hover:border-blue-500/30 transition-colors group" > 
                    <div className="w-10 h-10 bg-blue-600/10 border border-blue-500/20 rounded-sm flex items-center justify-center flex-shrink-0 group-hover:bg-blue-600/20 transition-colors"> 
                      <Icon className="text-blue-500 text-lg" /> 
                    </div> 
                    <div> 
                      <h4 className="text-white font-bold text-sm uppercase tracking-wide mb-1">{addon.name}</h4> 
                      <p className="text-slate-400 text-xs leading-relaxed">{addon.desc}</p> 
                    </div> 
                    <div className="ml-auto"> 
                      <span className="text-slate-600 text-xs font-bold uppercase tracking-wider">Quote</span> 
                    </div> 
                  </motion.div> 
                );
              })} 
            </div> 
          </div> 
          <motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} className="flex flex-col gap-6" > 
            <div className="bg-gradient-to-br from-blue-600 to-blue-800 p-10 rounded-sm shadow-[0_0_40px_rgba(37,99,235,0.2)]"> 
              <h3 className="text-2xl font-black text-white uppercase tracking-tight mb-4"> 
                Need a Custom Package? 
              </h3> 
              <p className="text-blue-100 text-sm leading-relaxed mb-8"> 
                Every vehicle is different. Tell us what you need and we'll build the right service for your situation and budget. 
              </p> 
              <div className="flex flex-col gap-3"> 
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-white text-blue-700 font-bold rounded-sm hover:bg-slate-100 transition-all uppercase tracking-wide text-sm" > 
                  Book Now <FiArrowRight /> 
                </a> 
                <a href="tel:9048312184" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border-2 border-white/30 text-white font-bold hover:bg-white/10 transition-all rounded-sm uppercase tracking-wide text-sm" > 
                  <FiPhone className="text-sm" /> Call (904) 831-2184 
                </a> 
              </div> 
            </div> 
            <div className="bg-slate-900 border border-slate-800 p-6 rounded-sm"> 
              <p className="text-slate-400 text-sm leading-relaxed"> 
                <span className="text-white font-bold">Note: </span> 
                Pricing may vary based on vehicle condition. A deposit may be required for new customers. We'll always communicate pricing clearly before any service begins. 
              </p> 
            </div> 
          </motion.div> 
        </div> 
      </div> 
    </section> 
  );
}